export const runbookStepActionsConstants = {
  ADD_AFTER: "Add After",
  ADD_BEFORE: "Add Before",
  ADD_TRUE: "Add True",
  ADD_FALSE: "Add False",
  ADD_FOR_LOOP_END_LOOP: "Add For Loop End Loop",
  UPDATE: "Update",
  DELETE: "Delete",
};
